import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height:  ${(p) => p.height ? p.height+'px' :"100%"};
  // height:  ${(p) => p.height ? p.height+'px' : p.height+'px'};
`;

export const LoginSectionWrapper = styled.div`
  margin: 2%;
  display: flex;
  flex-direction: column;
  padding: 2% 5%;
  width: 60%;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #fff; 
  box-shadow: inset 0 -3em 3em rgba(0, 0, 0, 0.1), 0 0 0 2px rgb(255, 255, 255),0.3em 0.3em 1em rgba(0, 0, 0, 0.3);
  // max-height: 80% !important;
  @media (max-width: 450px) {
    justify-content: center;
    align-items: center;
    width: 96%;
  }
  @media screen and (max-width: 800px) {
    width: 80%;
  }
`;


export const ChartTitle = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  margin-top: 15px;
  margin-bottom: 30px;
  width: 100%;
`;

export const Label  = styled.div`
  font-size: 14px;
  color: #A9A9A9;
`
export const TopLabel  = styled.div`
  font-size: 14px;
  color: #A9A9A9;
  width: 100%;
`
export const BottomText  = styled.div`
  font-size: 20px;
  color: #000000;
  margin: 5% 2% 2% 2%;
  text-align: center;
  width: 59%;
  @media screen and (max-width: 800px) {
    width:79%;
  }
`

export const HistoricalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media screen and (max-width: 600px) {
    display: block;
    margin-bottom: 2px;
    padding-bottom: 2px;
  }
`;
export const LeftTab =  styled.div`
  width: 49%;
  justify-content: flex-start;
  align-items: flex-start;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const HistoricalLabel = styled.div`
  font-size: 16px;
  color: #000000;
  font-weight: 600;
`;

export const RightTab =  styled.div`
  width: 49%;
  justify-content: flex-end;
  align-items: flex-end;
  text-align: end;
  margin-top: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 600px) {
    justify-content: flex-start;
    align-items: flex-start;
    text-align: start;
    width: 100%;
    margin-top: 15px;
  }
`;
export const Underlying =  styled.div`
  width: 100%;
  text-align: end;
  justify-content: end;
  align-items: end;
  display: flex;
  @media screen and (max-width: 600px) {
    justify-content: start;
    align-items: start;
    text-align: start;
  }
`;


export const Circle =  styled.div`
  height: 16px;
  width: 16px;
  border-radius: 8px;
  background-color: #0096FF;
  margin-right: 6px;
`;

export const SelectField =  styled.select`
  padding: 7px 10px;
  margin-bottom: 5px;
  border: 1px solid #ECECEC;
  color: #6F767E;
  border-radius: 10px;
  font-size: 14px;
  background-color: #F0F8FF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  cursor: pointer;
  .option-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  @media screen and (max-width: 500px) {
    width: 98%;;
  }
`;

export const Year =  styled.div`
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
  padding: 15px;
  @media screen and (max-width: 600px) {
    font-size: 10px;
    padding: 8px;
  }
`;

export const ChartContainer =  styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  // align-items: center;
  position: relative;
`;

export const VerticalText = styled.div`
  // writing-mode: vertical-lr;
  // text-orientation: mixed;
  font-size: 14px;
  font-weight: bold;
  color: #808080;
  margin-top:  ${(p) => p.type=== 'month' ? '17%':"13%"};
  display: inline-block;
  transform: rotate(-90deg) translateX(-100%);
  transform-origin: 0 0;
  position: absolute;
  left: -30px;
  text-transform: uppercase; 
  @media screen and (min-width: 600px) and (max-width: 880px) {
    margin-top: 7%;
    left: -20px;
  } 
  @media screen and (max-width: 600px) {
    margin-top: 5%;
    left: -14px;
    font-size: 10px;
  }
`;

export const ChartWrapper = styled.div`
   width: 100% !important;
`;

export const OptionField =  styled.option`
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer !important;
`;

export const OptionSpan=  styled.span`
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Divider = styled.div`
  border-bottom: 1px solid #D3D3D3;
  margin-bottom: 30px;
  padding-bottom: 30px;
  height: 1px;
  @media screen and (max-width: 600px) {
    margin-bottom: 10px;
    padding-bottom: 10px;
  }
`;

export const CustomOverlay = styled.div`
  position: fixed; 
  display: block; 
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 2; 
  cursor: pointer;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-top: 25%;
  z-index: 999;
  @media screen and (max-width: 700px) {
    padding-top: 45%;
  }
`;

export const EmptyDataContainer = styled.div`
  background-color: #000000;
  color: #ffffff;
  padding: 10px;
  border-radius: 6px;
  width: 79%;
  position: absolute;
  top: 30%;
  left: 12%;
  font-size: 12px;
  text-align: center;
  @media screen and (min-width: 401px) and (max-width: 600px) {
    width: 65%;
    left: 20%;
  }
  @media screen and (max-width: 400px) {
    top: 30%;
    width: 65%;
    font-size: 10px;
    padding: 8px;
    left: 20%;
  }

  @media screen and (min-width: 301px) and (max-width: 399px) {
    width: 65%;
    left: 20%;
  }
`;

